import React            from 'react';
import PropTypes 		from 'prop-types';
import ParseJsonTree    from './ParseJsonTree';

const JsonTree = ({value}) => {
	const json = typeof value === 'object' ? value : JSON.parse(value);

	return <ParseJsonTree values = {json} />
};


JsonTree.propTypes = {
	value: PropTypes.any,
};

export default JsonTree;
